import React from 'react';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import BreadCrumbOne from '../elements/breadcrumb/BreadCrumbOne';
// import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import SEO from '../common/SEO';


const PrivacyPolicy = () => {

    return (
        <>
            <SEO title="Privacy Policy" />
            {/* <ColorSwitcher /> */}
            <main className="main-wrapper">
                <HeaderOne />
                <BreadCrumbOne 
                title="Privacy Policy"
                page="Privacy Policy"
                />
                <div className="section-padding privacy-policy-area">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="privacy-policy-content">
                                <div className="section-title">
                                    <h5 className="title">At Graphify Infotech, your privacy is important to us. This Privacy Policy outlines how we collect, use, and protect your information.</h5>
                                </div>
                           
                                <h4>Information We Collect</h4>
                                <p>Personal Information: Name, email address, phone number, company details (when filling forms or registering).<br/>Usage Data: IP address, browser type, pages visited, time spent on our site.
                                <br/>Cookies: We use cookies for better user experience and analytics.</p>
                                <h4>How We Use Your Information</h4>
                                <p>To respond to inquiries or requests<br/>

To send service-related communications and updates<br/>

For internal analysis to improve our services<br/>

For promotional campaigns (only with your consent)<br/></p>
                                <h4>Data Security</h4>
                                <p>We implement industry-standard security practices, including encryption, firewalls, and secure servers to protect your data.</p>
                                <h4>Third-Party Sharing</h4>
                                <p>We do not sell or rent your personal data. We may share data with trusted partners only to fulfill services or as required by law.</p>
                                <h4>Your Rights</h4>
                                <p>• Request access to or correction of your data<br/>
• Opt-out of marketing communications<br/>
• Request deletion of personal data (subject to legal obligations)<br/></p>
 <h4>Contact Us</h4>
<p>If you have any questions regarding your privacy, please contact:<br/>
📧 Email: info@graphifyinfotech.com<br/>

📞 Phone: +91 96777 04249<br/></p>     </div>
                            </div>
                        </div>
                    </div>
                </div>
                <CtaLayoutOne />
            <FooterOne parentClass="" />
            </main>
        </>
    )
}

export default PrivacyPolicy;